import { render, staticRenderFns } from "./ViewStatement.vue?vue&type=template&id=05daf240&"
import script from "./ViewStatement.vue?vue&type=script&lang=js&"
export * from "./ViewStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports